import React, { useEffect, useMemo, useState } from 'react';
export const CheckboxInput = ({ id, name, type, checked, icon, label, disabled, onblur, onchange, }) => {
    const inputType = type || 'radio';
    const inputClassName = useMemo(() => (inputType === 'radio' ? `${inputType}btn` : inputType), [inputType]);
    const [checkboxValue, setCheckboxValue] = useState(checked);
    useEffect(() => setCheckboxValue(checked), [checked]);
    const onChange = () => {
        if (onchange) {
            onchange(undefined, !checkboxValue);
        }
        else {
            setCheckboxValue(!checkboxValue);
        }
    };
    return (React.createElement("label", { className: disabled ? 'disabled' : '' },
        React.createElement("span", { className: `checkcontainer ${disabled ? 'disabled' : ''}` },
            React.createElement("input", { id: id || name, type: inputType, checked: checkboxValue, disabled: disabled, onChange: onChange, onBlur: onblur }),
            React.createElement("span", { className: inputClassName })),
        ' ',
        icon && React.createElement("span", { className: "checklist-icon" }, icon),
        label || checkboxValue));
};
export const BasicCheckboxInput = ({ id, name, checked, icon, disabled, onblur, onchange, children, className, }) => {
    const [checkboxValue, setCheckboxValue] = useState(checked);
    useEffect(() => setCheckboxValue(checked), [checked]);
    const onChange = () => {
        if (onchange) {
            onchange(undefined, !checkboxValue);
        }
        else {
            setCheckboxValue(!checkboxValue);
        }
    };
    return (React.createElement("label", { className: `${disabled ? 'disabled' : ''} ${className}` },
        React.createElement("span", { className: `checkcontainer ${disabled ? 'disabled' : ''} mr-1` },
            React.createElement("input", { id: id || name, type: "checkbox", checked: checkboxValue, disabled: disabled, onChange: onChange, onBlur: onblur }),
            React.createElement("span", { className: 'checkbox' })),
        ' ',
        icon && React.createElement("span", { className: "checklist-icon" }, icon),
        children));
};
//# sourceMappingURL=Checkbox.js.map